import { render, staticRenderFns } from "./deviceType.vue?vue&type=template&id=0cf6ffc2&scoped=true&"
import script from "./deviceType.vue?vue&type=script&lang=js&"
export * from "./deviceType.vue?vue&type=script&lang=js&"
import style0 from "./deviceType.vue?vue&type=style&index=0&id=0cf6ffc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf6ffc2",
  null
  
)

export default component.exports